<template>
  <div
    :class="[
      'form-item-mobile-wrapper',
      { 'change-form-item-box-style': item.changeformItemBoxStyle },
    ]"
  >
    <div class="form-item-input-wrapper">
      <!-- area-code -->
      <div class="area-code-wrapper" @touchstart="handleInputFocus" @click="handleInputFocus">
        <div class="area-code-wrap">
          <label for="area-code" class="form-item-label">{{ i18n.t(item.areaCodeTitle) }}</label>
          <div
            id="area-code"
            class="area-code-input-wrapper"
            v-clickOutside="popoverOutsideClick"
            @click="toggleAreaList"
          >
            <span class="">+{{ dialCode }}</span>
            <img src="~img/icon-arrow-down.svg" alt="img-open" />
          </div>
        </div>
        <!-- phone -->
        <div class="area-tel-wrap">
          <label :for="item.field" class="form-item-label">{{ i18n.t(item.label) }}</label>
          <div class="input-wrapper">
            <SafeInput
              :id="item.field"
              :className="['form-item-input-phone', { 'error-border': item.errorShow }]"
              :maxlength="item.maxlength"
              :type="inputType"
              autocomplete="new-password"
              v-model="phone"
              @keydown="e => handleInput(e)"
              @input="e => (phone = e.target.value.replace(/[^\d]/g, '').replace(/\s+/g, ''))"
              data-input-type="mobile"
              role="phone number"
              @blur="onPhoneInput($event, item.field)"
            />
            <img
              v-if="item.comeForm === 'UserInfo' || item.comeForm === 'SignUp2'"
              class="eye"
              :src="item.on ? eyeOn : eyeOff"
              @click="clickEye(item)"
              alt=""
            />
          </div>
          <p v-if="item.errorShow" :class="{ 'error-msg': item.errorShow }">{{ item.errorMsg }}</p>
        </div>
      </div>
      <!-- 下拉展示部分 -->
      <transition name="fade">
        <div class="area-code-popover" ref="" v-show="showAreaCodePopover">
          <div class="area-code-popover-content">
            <div class="search-input-wrapper">
              <!-- <label for="area-code" class="hide">area code</label> -->
              <input
                id="area-code"
                type="text"
                class="search-input"
                autocomplete="off"
                v-model="searchText"
                data-search-type="search"
              />
              <img class="icon-search" src="~img/search-Icon.png" alt="search area code" />
            </div>
            <div class="area-code-list-wrapper">
              <ul class="area-code-list" role="listbox">
                <li
                  :data-index="index"
                  :key="`${index}-${ctr.telabbr}`"
                  role="option"
                  v-for="(ctr, index) in showList"
                  class="area-code-item"
                  @click="areaItemClick(ctr)"
                >
                  <!-- <span class="area-code-flag" :class="ctr.ios2 && ctr.ios2.toLowerCase()" aria-hidden="true"></span> -->
                  <span class="area-name">{{ ctr.name }}</span>
                  &nbsp;
                  <span class="area-code">(+{{ ctr.telabbr }})</span>
                </li>
                <li role="option" class="search-no-results" v-show="showList.length === 0">
                  {{ i18n.t('search-box-no-found') }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="slot-wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
  import { clickOutside } from '@/utils/directive.js';
  import i18n from '@/i18n';
  import SafeInput from '@/components/SafeInput';

  export default {
    data() {
      return {
        i18n,
        list: [],
        searchText: '',
        showAreaCodePopover: false,
        inputReadonly: true,
        phone: '',
        inputType: this.item.comeForm === 'UserInfo' || 'SignUp2' ? 'password' : 'text',
        eyeOn: require('@/assets/images/icon-feather-eye-on.svg'),
        eyeOff: require('@/assets/images/icon-feather-eye-off.svg'),
      };
    },
    components: {
      SafeInput,
    },

    props: {
      item: {
        type: Object,
        default: () => {},
      },

      dialCode: {
        type: String,
        default: '1',
      },

      areaList: {
        type: Array,
        default: () => [],
      },

      itemFormValue: {
        type: Object,
        default: () => {},
      },
    },

    mounted() {
      if (this.itemFormValue?.phone && this.itemFormValue?.exphone) {
        const { phone, exphone } = this.itemFormValue;
        this.phone = phone;
        this.$emit('update:dialCode', exphone);
      } else {
        // TODO: 首次执行时，设置一个默认值
        this.$emit('value', { exphone: '1' }, 'exphone');
      }
    },

    methods: {
      handleInput(e) {
        // if (!item.on && item.comeForm === 'UserInfo') this.phone = ''
        if (e.keyCode === 8 && !this.item.on && this.item.comeForm === 'UserInfo') {
          this.phone = '';
        }
      },
      clickEye(item) {
        item.on = !item.on;
        if (item.on) {
          return (this.inputType = 'text');
        }
        return (this.inputType = 'password');
      },
      onPhoneInput(e, field) {
        const { value } = e.target;

        // TODO: 此处会有错峰触发的问题，当exphone修改了，这里并不会修改，同时需要考虑是否要同时回传mobileNumber和phone
        this.$emit(
          'value',
          { mobileNumber: value === '' ? '' : `+${this.dialCode}${value}` },
          field,
        );
        this.$emit('value', { phone: value }, 'phone');

        // 如果没有选择exphone的情况下，也需要把最新的exphone返回出去
        this.$emit('value', { exphone: this.dialCode }, 'exphone');
      },

      toggleAreaList() {
        this.showAreaCodePopover = !this.showAreaCodePopover;
      },

      areaItemClick(ctr) {
        this.showAreaCodePopover = false;
        this.$emit('update:dialCode', ctr.telabbr);
        this.$emit('value', { exphone: ctr.telabbr }, 'exphone');
      },

      popoverOutsideClick(e) {
        if (e.target.className.includes('search-input')) return;
        this.showAreaCodePopover && (this.showAreaCodePopover = false);
      },

      handleInputFocus() {
        this.inputReadonly = false;
      },
    },

    computed: {
      showList() {
        let searchText = this.searchText || '';
        let data = this.areaList.filter(ctr => ctr.name && ctr.telabbr && ctr.code);
        if (searchText.length === 0) {
          return data;
        }
        searchText = searchText.replace('+', '\\+');
        data = data.filter(ctr => {
          const reg = new RegExp(searchText, 'gi');
          const nameFlag = reg.test(ctr.name);
          const dialCodeFlag = reg.test(ctr.telabbr);
          const iso2Flag = reg.test(ctr.ios2);
          return nameFlag || dialCodeFlag || iso2Flag;
        });
        return data;
      },
    },

    directives: { clickOutside },

    watch: {
      showAreaCodePopover(newVal) {
        if (!newVal) {
          this.searchText = '';
        }
      },

      phone(nVal) {
        if (!nVal && this.item.comeForm === 'UserInfo') return;
      },
    },
  };
</script>

<style lang="scss">
  @import './index';
  @import './mobile';
</style>
